var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"icon-left":"eye"},on:{"click":function($event){$event.preventDefault();return _vm.showModal()}}},[_vm._v("\n    View PDF\n")])}
var staticRenderFns = []

export { render, staticRenderFns }